import { LoginCallback as AuthenticationLoginCallback } from 'module/authentication/components/login-callback';
import { LoginCallbackErrorPage } from 'module/authentication/components/login-callback/error';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { ROCKETLANE_EMAILS } from 'constant';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  error: Error;
}

const CallbackError: FC<Props> = ({ error }) => {
  return (
    <LoginCallbackErrorPage
      error={error}
      supportEmail={ROCKETLANE_EMAILS.support}
      loginUrl="/login"
    />
  );
};

export const LoginCallback = () => {
  const navigate = useNavigate();

  return (
    <AuthenticationLoginCallback
      errorComponent={CallbackError}
      loadingElement={<PageLoading />}
      postLoginRedirectUrl={'/login'}
      onUserAuthenticatedInOkta={() => navigate('/')}
    />
  );
};
